import axios from "axios";
import { PromiseHandler } from "../../../handlers";
import { DealsFetchFailed } from "../errors";
/**
 * Handles annotation schema retrieval for the current user's organization.
 *
 * This module provides an alternative way to fetch annotation schemas for users who are
 * blocked from accessing the organization API endpoint due to permission restrictions.
 */
class DealAnnotationSchema extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "deals-annotation-schema");
    }
    /**
     * Required by Handler base class - not used for annotation schema
     * since we don't support finding items by filters
     */
    async findItems() {
        throw new Error("findItems not supported for annotation schema");
    }
    /**
     * Required by Handler base class - not used for annotation schema
     * since this is read-only data
     */
    async saveItem() {
        throw new Error("saveItem not supported for annotation schema");
    }
    /**
     * Required by Handler base class - not used for annotation schema
     * since this is read-only data
     */
    async deleteItem() {
        throw new Error("deleteItem not supported for annotation schema");
    }
    /**
     * Retrieves the annotation schema for the current user's organization.
     *
     * This method provides an alternative way to fetch annotation schemas for users (anyone
     * who is NOT the root user, dev@madhive.com) who are blocked from accessing the organization
     * API endpoint due to permission restrictions.
     *
     * @returns A promise that resolves to the annotation schema for the user's organization.
     * @throws {DealsFetchFailed} When the API call fails or returns an error.
     */
    async get() {
        try {
            const response = await axios.get(`${this.sdk.urls.baseAPIUrl}/inv-annotations-schema`, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const serviceSchema = response.data.data;
            // Transform from service format to client format (same as organization module)
            const annotationSchema = {
                fields: serviceSchema.fields.map((field) => ({
                    key: field.key,
                    label: field.label,
                    type: field.type,
                    ...(field.value?.string_list && {
                        value: { stringList: field.value.string_list }
                    })
                }))
            };
            return annotationSchema;
        }
        catch (error) {
            throw new DealsFetchFailed(error);
        }
    }
}
export default DealAnnotationSchema;
//# sourceMappingURL=index.js.map